import {useLocalStorage} from "@variocube/app-ui";

export function useLastUserEmail() {
	return useLocalStorage<string | undefined>("lastUserEmail", undefined);
}
